import store from '../store/store';
import TranslationMode from '../store/schema/TranslationMode';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function checkOptionsFallback() {
    // if user has saved option as automatic but no longer has feature enabled
    // revert back to suggestion mode
    if (
        !isFeatureEnabled('rp-inlineTranslationAutomatic') &&
        store.settings.translationMode === TranslationMode.Automatic
    ) {
        store.settings.translationMode = TranslationMode.Suggest;
    }

    // If target language feature is disabled ensure we revert saved setting
    if (!isFeatureEnabled('rp-inlineTranslation-targetLanguage') && store.settings.targetLanguage) {
        store.settings.targetLanguage = '';
    }
}
